<script>
  import { Text, Caption } from '../..'
  import {
    getContainerClass,
    getWrapperClass,
    getInputClass,
    getLabelClass,
    getDescriptionClass,
    getErrorClass,
  } from '../utils'

  export let label
  export let description = undefined
  export let disabled = false
  export let checked = false
  export let withError = false
  export let singleString = false

  $: containerClassName = getContainerClass({
    className: $$props.class || '',
    disabled,
    checked,
  })
  $: wrapperClassName = getWrapperClass()
  $: inputClassName = getInputClass({ withError: !!withError })
  $: labelClassName = getLabelClass({ singleString })
  $: descriptionClassName = getDescriptionClass({ singleString })
  $: errorClassName = getErrorClass({ singleString })
</script>

<label class={containerClassName}>
  <span class={wrapperClassName}>
    <input
      type="radio"
      on:click
      on:keydown
      on:select
      on:change
      on:focus
      on:blur
      {...$$restProps}
      {checked}
      {disabled}
      class={inputClassName} />
    <Text class={labelClassName}>{label}</Text>
    {#if description !== undefined}
      <Caption class={descriptionClassName}>{description}</Caption>
    {/if}
    {#if typeof withError === 'string'}
      <Caption class={errorClassName}>{withError}</Caption>
    {/if}
  </span>
</label>
